/* global kelaL10n */

import './regular/jquery.tablesorter';
import './regular/modernizr';
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueScrollTo from 'vue-scrollto';
import {VueMasonryPlugin} from 'vue-masonry';
import moment from 'moment';
import cookies from './regular/cookies';

// import Socialfeed from './vue/socialfeed/index.vue'

cookies()
Vue.use(VueResource)
Vue.use(VueScrollTo)
Vue.use(VueMasonryPlugin)

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY');
    }
});

// This and all subsequent DEBUG statements will be removed in minifed version
//if ( typeof DEBUG === 'undefined' ) DEBUG = true;

jQuery(function() {

    "use strict";

    // VUE COMPONENTS

    const vueBlocks = [
      {
          // selector: '.social-feed',
          // components: { Socialfeed },
      },

  ];

  vueBlocks.forEach((item) => {
      const {selector, components} = item;
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => {

          new Vue({
              el: `#${element.id}`,
              components,
          })
      });
  });

// VUE ENDS

    var windowWidth = window.innerWidth;
    jQuery(window).resize(function(){
        windowWidth = window.innerWidth;
    });

    // Extend jQuery to allow for fuzzy searches
    jQuery.expr[':'].Contains = function( a, i, m ) {
        return ( a.textContent || a.innerText || '' ).toUpperCase().indexOf( m[3].toUpperCase() ) >= 0;
    };

    // Extend jQuery to check for existing elements
    jQuery.fn.exists = function() { return this.length > 0; };

    // min contentarea height (with sidenav)
    function minContentareaHeight(){
        if (jQuery('.contentarea').length > 0) {
            if (jQuery(window).width() > 760) {
                var minHeight = jQuery('.sidenav').height() + jQuery('.breadcrumbs').height() - jQuery('.article__top').height() + 30;
                jQuery('.contentarea').css({"minHeight" : minHeight+"px"});
            } else {
                jQuery('.contentarea').css({"minHeight" : "auto"});
            }
        } else if (jQuery('.template-page').length > 0) {
            if (jQuery(window).width() > 760) {
                var minHeight = jQuery('.sidenav').outerHeight() + jQuery('.breadcrumbs').outerHeight() + 60;
                jQuery('article.with-sidenav').css({"minHeight" : minHeight+"px"});
            } else {
                jQuery('article.with-sidenav').css({"minHeight" : "auto"});
            }
        } else {
            var minHeightTop = jQuery('.sidenav').height() + 90;
            jQuery('.article__top').css({"minHeight" : minHeightTop+"px"});
        }
    }

    // Set classes for cached menu
    jQuery('nav').find('a[href="' + location.href.split('#')[0] + '"]').parent().addClass('current-menu-item').parents('.menu-item').addClass('current-menu-ancestor');

    // Add aria-labels to navigation expands
    jQuery('.menu > li > .link-wrapper').each(function(ev){
        var name = jQuery(this).text();
        var text = kelaL10n.sub + ' ' + name;
        jQuery(this).find('button').attr('aria-label', text);
    });

    jQuery('.sub-menu button').remove(); // hack to remove all buttons in subnav

    jQuery('.menu-item:not(.menu-item-has-children) button').remove(); // hack to remove all buttons if no child pages

    // Toggle navigation
    jQuery('.header-navigation__toggle-navigation').on('click', function () {
        // Remove other open classes first
        jQuery('.site-header').removeClass('search-open lang-open');
        // Toggle navigation
        jQuery('.site-header').toggleClass('nav-open');
    });

    jQuery('.header-navigation__toggle-search').on('click', function () {
        // Remove other open classes first
        jQuery('.site-header').removeClass('nav-open lang-open');
        // Toggle search
        jQuery('.site-header').toggleClass('search-open');
        console.log('search toggle');
    });

    jQuery('.header-navigation__toggle-lang').on('click', function () {
        // Remove other open classes first
        jQuery('.site-header').removeClass('nav-open search-open');
        // Toggle language
        jQuery('.site-header').toggleClass('lang-open');
        console.log('lang toggle');
    });

    jQuery('.header-navigation__toggle').on('click', function(){
        jQuery('.site-header').toggleClass('nav-open');
    });

    jQuery('.header-navigation nav .expand').on('click', function(){
        var target = jQuery(this).parent().parent();
        var mainlevel = jQuery(this).parents('.sub-menu').parent();

        if (jQuery(target).hasClass('section-open')) {
            jQuery(this).attr('aria-expanded', false);
        } else {
            jQuery(this).attr('aria-expanded', true);
        }
        jQuery('.header-navigation__main > ul > li.section-open').not(mainlevel).not(target).removeClass('section-open');
        jQuery(target).toggleClass('section-open');
        return false;
    });

    if(windowWidth > 760){
        var menuclosedelay = "";
        jQuery('.header-navigation__main').mouseenter(function(){
            clearTimeout(menuclosedelay);
        }).mouseleave(function(){
            menuclosedelay = setTimeout(function(){
                jQuery('.header-navigation__main .section-open').removeClass('section-open');
            }, 500);
        });
    }
    jQuery('.header-navigation__lang .current-lang a').on('click', function(){
        jQuery('.header-navigation__lang .lang_sel_click').toggleClass('active');

        if (jQuery('.header-navigation__lang .lang_sel_click').hasClass('active')) {
            jQuery(this).attr('aria-expanded', true);
        } else {
            jQuery(this).attr('aria-expanded', false);
        }

        return false;
    });

    jQuery('.header-navigation__shortcuts .toggle_quicklinks').on('click', function(){
        var target = jQuery('.header-navigation__shortcuts .toggle_quicklinks');
        jQuery('.header-navigation__shortcuts').toggleClass('active');

        if (jQuery('.header-navigation__shortcuts').hasClass('active')) {
            jQuery(target).attr('aria-expanded', false);
        } else {
            jQuery(target).attr('aria-expanded', true);
        }

        return false;
    });
    jQuery('.header-navigation__shortcuts').mouseout(function(){
        jQuery('.header-navigation__shortcuts').removeClass('active');
    });

    //Sidebar navigation
    jQuery('.sidenav li').removeClass('page_item_has_children current_page_ancestor current_page_parent');
    jQuery('.sidenav .children li').removeClass('current_page_item current-menu-item');
    //jQuery('.sidenav').find('a[href="' + location.href.split('#')[0] + '"]').parent().addClass('active').parents('.children').parent().addClass('active');
    jQuery('.sidenav').find('a[href="' + location.href.split('#')[0] + '"]').parent().addClass('active');
    jQuery('.sidenav').find('a[href="' + location.href.split('#')[0] + '"]').parent().parents('.children').parent().addClass('active');
    /*
    if(windowWidth > 680){
        var menudelay = "";
        var menuclosedelay = "";
        jQuery('.header-navigation__main > ul > li').mouseenter(function(){
            var target = jQuery(this);
            var targetdropdown = jQuery(this).children('ul');
            clearTimeout(menuclosedelay);
            menudelay = setTimeout(function(){
                jQuery('.header-navigation nav .section-open').not(jQuery(target).parents('li')).removeClass('section-open').children('ul').delay(200).fadeOut(100);
                jQuery(targetdropdown).stop().fadeIn(200);
                jQuery(target).delay(200).addClass('section-open');
            }, 300);
        }).mouseleave(function(){
            var target = jQuery(this);
            var targetdropdown = jQuery(this).children('ul');
            clearTimeout(menudelay);
            menuclosedelay = setTimeout(function(){
                jQuery(targetdropdown).stop().fadeOut(200);
                jQuery(target).delay(200).removeClass('section-open');
            }, 200);
        });
    }
    */

    jQuery('.printpage').on('click', function(){
        window.print();
    });

    jQuery('.feedback').on('click', function(){
        jQuery('.feedback__form').slideToggle(200);
        jQuery(this).toggleClass('active');

        if (jQuery(this).hasClass('active')) {
            jQuery(this).attr('aria-expanded', true);
        } else {
            jQuery(this).attr('aria-expanded', false);
            jQuery('.feedback__form textarea').focus();
        }
        jQuery('.share .icon-share').removeClass('active');
        jQuery('.share-dropdown').slideUp(200);
        jQuery('.feedback').focus();

        return false;
    });

    jQuery('.share .icon-share').on('click', function(){
        jQuery('.share-dropdown').slideToggle(200);
        jQuery(this).toggleClass('active');

        if (jQuery(this).hasClass('active')) {
            jQuery(this).attr('aria-expanded', true);
        } else {
            jQuery(this).attr('aria-expanded', false);
            jQuery('.feedback__form textarea').focus();
        }

        jQuery('.feedback').removeClass('active');
        jQuery('.feedback__form').slideUp(200);
        return false;
    });

    if( jQuery('.with-sidenav').length > 0){
        minContentareaHeight();
        jQuery(window).resize(minContentareaHeight);
    }

    // dirty table wrapper
    jQuery('article').find('table').wrap('<div class="tablewrapper"></div>');

    // back to top
    jQuery('.back_to_top').on('click', function(){
        jQuery('html, body').animate({scrollTop: "0"}, 250);
        return false;
    });

    // Instant search
    jQuery('.header-navigation').find('.search-form').each(function() {

        var jQueryform = jQuery(this),
            jQueryfield = jQueryform.find('.search-field');

        jQueryform.find('fieldset').append( jQuery('#search-suggestions-template').html() );

        var container_selector = '.search-container',
            tag_selector = '.list-item',
            jQuerycontainer = jQueryform.find( container_selector ),
            jQuerytags = jQuerycontainer.find( tag_selector ),
            jQuerylink;

        // Bind key strokes when navigating through search suggestion links
        jQuerytags.find('a').on('keyup', function( e ) {

            switch( e.keyCode ) {

                // Escape: Clear the search field
                case 27 :
                    jQueryfield.focus().empty();
                break;

                // Key up: Jump to previous link or return to search field
                case 38 :

                    e.preventDefault();

                    if ( jQuery(this).parent('.list-item').prevAll('.list-item:visible').first().get(0) ) {
                        jQuery(this).parent('.list-item').prevAll('.list-item:visible').first().find('a').focus();
                    } else {
                        // Focus on search field and make sure cursor is at the end of the text
                        jQueryfield.focus().val( jQueryfield.val() );
                    }
                break;

                // Key down: Jump to next link or return to search field
                case 40 :
                    e.preventDefault();

                    if ( jQuery(this).parent('.list-item').nextAll('.list-item:visible').first().get(0) ) {
                        jQuery(this).parent('.list-item').nextAll('.list-item:visible').first().find('a').focus();
                    } else {
                        // Highlight first item on the list to scroll back up
                        jQuerycontainer.find('.list-item:visible').first().find('a').focus();
                        // Focus on search field and make sure cursor is at the end of the text
                        jQueryfield.focus().val( jQueryfield.val() );
                    }
                break;
            }
        });

        // Bind key strokes for the actual search field
        jQueryfield.on('keyup', function( e ) {

            jQuery(this).change();

            switch( e.keyCode ) {

                // Escape: Clear search field
                case 27 :
                    jQueryfield.val('').change();
                break;

                // Key up: Go to the last search suggestion on the list
                case 38 :
                    e.preventDefault();
                    jQuerycontainer.find('.list-item:visible').last().find('a').focus();
                break;


                // Key down: Go to the first search suggestion on the list
                case 40 :
                    e.preventDefault();
                    jQuerycontainer.find('.list-item:visible').first().find('a').focus();
                break;

            }

        // Process user input
        }).on('change', function() {

            var search_term = jQuery(this).val();

            if ( search_term ) {

                // Update current search words
                jQuerycontainer.find('.search-words').empty().text( search_term );

                // Show container, but hide tags
                jQuerycontainer.removeClass('hide').attr('aria-hidden', false);
                jQuerytags.addClass('hide');

                // Show tags containing the search words
                jQuerycontainer.find( tag_selector + ':Contains(' + search_term + ')' ).removeClass('hide');

                // Hide container if no tags matched
                if ( jQuerycontainer.find(  tag_selector + ':visible' ).length === 0 ) {
                    jQuerycontainer.addClass('hide').attr('aria-hidden', true);
                }

            // Search field is empty, hide everything
            } else {
                jQuerycontainer.addClass('hide').attr('aria-hidden', 'true');
                jQuerytags.addClass('hide');
            }

        });
    });

    // Instant search - Countries
    jQuery('.countries').each(function() {

        var jQueryform = jQuery(this),
            jQueryfield = jQueryform.find('.search-field');

        var container_selector = '.search-container',
            tag_selector = '.list-item',
            jQuerycontainer = jQueryform.find( container_selector ),
            jQuerytags = jQuerycontainer.find( tag_selector ),
            jQuerylink;

        // Bind key strokes when navigating through search suggestion links
        jQuerytags.find('a').on('keyup', function( e ) {

            switch( e.keyCode ) {

                // Escape: Clear the search field
                case 27 :
                    jQueryfield.focus().empty();
                break;

                // Key up: Jump to previous link or return to search field
                case 38 :

                    e.preventDefault();

                    if ( jQuery(this).parent('.list-item').prevAll('.list-item:visible').first().get(0) ) {
                        jQuery(this).parent('.list-item').prevAll('.list-item:visible').first().find('a').focus();
                    } else {
                        // Focus on search field and make sure cursor is at the end of the text
                        jQueryfield.focus().val( jQueryfield.val() );
                    }
                break;

                // Key down: Jump to next link or return to search field
                case 40 :
                    e.preventDefault();

                    if ( jQuery(this).parent('.list-item').nextAll('.list-item:visible').first().get(0) ) {
                        jQuery(this).parent('.list-item').nextAll('.list-item:visible').first().find('a').focus();
                    } else {
                        // Highlight first item on the list to scroll back up
                        jQuerycontainer.find('.list-item:visible').first().find('a').focus();
                        // Focus on search field and make sure cursor is at the end of the text
                        jQueryfield.focus().val( jQueryfield.val() );
                    }
                break;
            }
        });

        // Bind key strokes for the actual search field
        jQueryfield.on('keyup', function( e ) {

            jQuery(this).change();

            switch( e.keyCode ) {

                // Escape: Clear search field
                case 27 :
                    jQueryfield.val('').change();
                break;

                // Key up: Go to the last search suggestion on the list
                case 38 :
                    e.preventDefault();
                    jQuerycontainer.find('.list-item:visible').last().find('a').focus();
                break;


                // Key down: Go to the first search suggestion on the list
                case 40 :
                    e.preventDefault();
                    jQuerycontainer.find('.list-item:visible').first().find('a').focus();
                break;

            }

        // Process user input
        }).on('change', function() {

            var search_term = jQuery(this).val();

            if ( search_term ) {

                // Update current search words
                jQuerycontainer.find('.search-words').empty().text( search_term );

                // Show container, but hide tags
                jQuerycontainer.removeClass('hide').attr('aria-hidden', false);
                jQuerytags.addClass('hide');

                // Show tags containing the search words
                jQuerycontainer.find( tag_selector + ':Contains(' + search_term + ')' ).removeClass('hide');

                // Hide container if no tags matched
                if ( jQuerycontainer.find(  tag_selector + ':visible' ).length === 0 ) {
                    jQuerycontainer.addClass('hide').attr('aria-hidden', true);
                }

            // Search field is empty, hide everything
            } else {
                jQuerycontainer.addClass('hide').attr('aria-hidden', 'true');
                jQuerytags.addClass('hide');
            }

        });
    });


    // Instant search - Countries
    jQuery('.kunnat').each(function() {

        var jQueryform = jQuery(this),
            jQueryfield = jQueryform.find('.search-field');

        var container_selector = '.search-container',
            tag_selector = '.list-item',
            jQuerycontainer = jQueryform.find( container_selector ),
            jQuerytags = jQuerycontainer.find( tag_selector ),
            jQuerylink;

        // Bind key strokes when navigating through search suggestion links
        jQuerytags.find('a').on('keyup', function( e ) {

            switch( e.keyCode ) {

                // Escape: Clear the search field
                case 27 :
                    jQueryfield.focus().empty();
                break;

                // Key up: Jump to previous link or return to search field
                case 38 :

                    e.preventDefault();

                    if ( jQuery(this).parent('.list-item').prevAll('.list-item:visible').first().get(0) ) {
                        jQuery(this).parent('.list-item').prevAll('.list-item:visible').first().find('a').focus();
                    } else {
                        // Focus on search field and make sure cursor is at the end of the text
                        jQueryfield.focus().val( jQueryfield.val() );
                    }
                break;

                // Key down: Jump to next link or return to search field
                case 40 :
                    e.preventDefault();

                    if ( jQuery(this).parent('.list-item').nextAll('.list-item:visible').first().get(0) ) {
                        jQuery(this).parent('.list-item').nextAll('.list-item:visible').first().find('a').focus();
                    } else {
                        // Highlight first item on the list to scroll back up
                        jQuerycontainer.find('.list-item:visible').first().find('a').focus();
                        // Focus on search field and make sure cursor is at the end of the text
                        jQueryfield.focus().val( jQueryfield.val() );
                    }
                break;
            }
        });

        // Bind key strokes for the actual search field
        jQueryfield.on('keyup', function( e ) {

            jQuery(this).change();

            switch( e.keyCode ) {

                // Escape: Clear search field
                case 27 :
                    jQueryfield.val('').change();
                break;

                // Key up: Go to the last search suggestion on the list
                case 38 :
                    e.preventDefault();
                    jQuerycontainer.find('.list-item:visible').last().find('a').focus();
                break;


                // Key down: Go to the first search suggestion on the list
                case 40 :
                    e.preventDefault();
                    jQuerycontainer.find('.list-item:visible').first().find('a').focus();
                break;

            }

        // Process user input
        }).on('change', function() {

            var search_term = jQuery(this).val();

            if ( search_term ) {

                // Update current search words
                jQuerycontainer.find('.search-words').empty().text( search_term );

                // Show container, but hide tags
                jQuerycontainer.removeClass('hide').attr('aria-hidden', false);
                jQuerytags.addClass('hide');

                // Show tags containing the search words
                jQuerycontainer.find( tag_selector + ':Contains(' + search_term + ')' ).removeClass('hide');

                // Hide container if no tags matched
                if ( jQuerycontainer.find(  tag_selector + ':visible' ).length === 0 ) {
                    jQuerycontainer.addClass('hide').attr('aria-hidden', true);
                }

            // Search field is empty, hide everything
            } else {
                jQuerycontainer.addClass('hide').attr('aria-hidden', 'true');
                jQuerytags.addClass('hide');
            }

        });
    });
    jQuery('.kunnat .search-suggestions a').on('click', function(){
        var parentField = jQuery(this).closest('fieldset');
        var kunta = jQuery(this).text();
        jQuery(parentField).children('.search-field').val(kunta);
        jQuery('.kunnat .search-container').addClass('hide');
        return false;
    });

    //
    jQuery('.change_healthcare').on('submit',function(){
        var error = false;
        jQuery('.required', this).each(function(){
            jQuery(this).removeClass('error');
            if( jQuery('input', this).val() === '' ){
                jQuery(this).addClass('error');
                error = true;
            }
            if( jQuery('input[type=checkbox]', this).length > 0 ){
                if( jQuery('input[type=checkbox]:checked', this).length === 0 ){
                    jQuery(this).addClass('error');
                    error = true;
                }
            }
        });
        if(error === true){
            var errorpos = jQuery('.error:first').offset().top;
            jQuery('body, html').animate({scrollTop: errorpos - 16 + 'px' }, 100);
            return false;
        } else {
            /* jshint ignore:start */
            ga('send', 'event', 'button', 'click', 'Ilmoitus terveysaseman vaihtamisesta, Jatka tulostukseen');
            /* jshint ignore:end */
        }
    });
    jQuery('.change_healthcare__print').on('click', function() {
        /* jshint ignore:start */
        ga('send', 'event', 'button', 'click', 'Ilmoitus terveysaseman vaihtamisesta, Tulosta');
        /* jshint ignore:end */
    });
    jQuery('.change_healthcare').on('change', '.error input', function() {
        if( jQuery(this).attr('type') === 'checkbox' ){
            if( jQuery(this).prop('checked') === true ){
                jQuery(this).parents('.error').removeClass('error');
            }
        } else {
            if( jQuery(this).val() !== ''){
                jQuery(this).parents('.error').removeClass('error');
            }
        }
    });

    // Gravity forms rs_skip class
    jQuery('.gform_validation_container').addClass('rs_skip');
    jQuery('#gform_ajax_frame_1').addClass('rs_skip');

    // Add opens in a new tab text to screen readers */
    jQuery("main a[target='_blank']").append("<span class='screen-reader-text'> (" + kelaL10n.tab +")</span><span class='icon-ext-link' aria-hidden='true'></span>");

    // Tag search
    if ( jQuery('.tag-search').exists() ) {

        var container_selector = '.list-items',
            tag_selector = '.tag',
            list_selector = '.list',

            jQuerylists = jQuery( list_selector ),
            jQuerytags = jQuery( tag_selector ),
            jQuerycontainers = jQuery( container_selector );

        jQuery('.tag-search').on('change', function() {
            var search_term = jQuery(this).val();

            if ( search_term ) {
                jQuerycontainers.show();

                jQuerylists.each(function() {
                    var jQuerylist = jQuery(this);

                    jQuerylist.find( tag_selector + ':Contains(' + search_term + ')' ).show();
                    jQuerylist.find( tag_selector + ':not(:Contains(' + search_term + '))' ).hide();

                    // Show or hide parent containers if tags are present or missing
                    if ( jQuerylist.find(  tag_selector + ':visible' ).length === 0 ) {
                        jQuerylist.parents( container_selector ).hide();
                    } else {
                        jQuerylist.parents( container_selector ).show();
                    }
                });

            // Search field is empty, show everything
            } else {
                jQuerycontainers.show();
                jQuerytags.show();
            }

        }).on('keyup', function() {
            jQuery(this).change();
        });

    }

    // wrap iframes

    jQuery('article .contentarea iframe').not('iframe.rs_skip').wrap( "<div class='iframe-wrap'></div>" );


    // open nav subfolders if mobilé

    if( jQuery(window).width() < 760 ){
        jQuery('.header-navigation__main .link-wrapper.current-menu-anchestor, .header-navigation__main .link-wrapper.current-menu-item, .header-navigation__secondary .link-wrapper.current-menu-anchestor, .header-navigation__secondary .link-wrapper.current-menu-item').parents('.menu-item').addClass('section-open');
    }

    // show country list

    jQuery('.countrylist').addClass('hide');
    jQuery('.countrylist-toggle').on('click', function(){
        jQuery('.countrylist-toggle span').toggleClass('icon-plus');
        jQuery('.countrylist-toggle span').toggleClass('icon-minus');

        jQuery('.countrylist').toggleClass('hide');

        if (jQuery('.countrylist').hasClass('hide')) {
            jQuery('.countrylist-toggle').attr('aria-expanded', false);
        } else {
            jQuery('.countrylist-toggle').attr('aria-expanded', true);
        }
        return false;
    });

    // feedback expand

    jQuery('.aside-feedback textarea').on('change', function(){
        if( jQuery(this).val() !== "" ){
            jQuery(this).addClass('filled');
        }else{
            jQuery(this).removeClass('filled');
        }
    });

    // wizard

    jQuery('.wizard').show();
    var i = 0;

    jQuery('.wizard').on('click', '.wizard__answers a', function() {
        var target = jQuery(this).attr('href');
        var link = jQuery(this);
        jQuery('.wizard__loading').show();
        jQuery('.wizard__content').load( target + " .wizard__content__inner", function(){
            jQuery('.wizard__breadcrumb').append(link);
            i = i+1;
            jQuery('.wizard .back').show();
            jQuery('.wizard .wizard__breadcrumb').show();
            jQuery('.wizard__loading').hide();
        });
        return false;
    });

    jQuery('.wizard').on('click', '.wizard__breadcrumb a', function() {
        var target = jQuery(this).attr('href');
        i = jQuery('.wizard__breadcrumb a').index(this);
        jQuery('.wizard__loading').show();
        jQuery('.wizard__content').load( target + " .wizard__content__inner", function(){
            jQuery('.wizard__breadcrumb a:gt('+i+')').remove();
            if(i===0){
                jQuery('.wizard .back').hide();
                jQuery('.wizard .wizard__breadcrumb').hide();
            }
            jQuery('.wizard__loading').hide();
        });
        return false;
    });

    jQuery('.wizard').on('click', '.back', function() {
        i = i-1;
        var target = jQuery('.wizard__breadcrumb a:eq('+i+')').attr('href');
        jQuery('.wizard__loading').show();
        jQuery('.wizard__content').load( target + " .wizard__content__inner", function(){
            jQuery('.wizard__breadcrumb a:gt('+i+')').remove();
            if(i===0){
                jQuery('.wizard .back').hide();
                jQuery('.wizard .wizard__breadcrumb').hide();
            }
            jQuery('.wizard__loading').hide();
        });
        return false;
    });

    jQuery('.anchor-links__top a').on('click', function(){
        var target = jQuery(this).attr('href');
        var position = jQuery(target).position().top;
        jQuery('html,body').animate({scrollTop: position-16+'px'}, 500);
        return false;
    });

    // Make story teaser div clickable

    jQuery('.stories-container').on('click', function() {
        var first_href = jQuery(this).find('a:first').attr('href');

        if(first_href) {
            window.location = jQuery(this).find('a:first').attr('href');
            return false;
        }
    });

    // Make frontpage stories teaser div clickable

    jQuery('.stories-content').on('click', function() {
        var first_href = jQuery(this).find('a:first').attr('href');

        if(first_href) {
            window.location = jQuery(this).find('a:first').attr('href');
            return false;
        }
    });


    // Add itemprop position for each bredcrumb

    jQuery( "li[itemprop=itemListElement]" ).each(function( index ) {
        var i = index+1;
        jQuery(this).append( "<meta itemprop='position' content='"+i+"' />" );
    });

  });
